"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payout = exports.DiscriminatorEnum = void 0;
var Hash_1 = require("./Hash");
var ContractId_1 = require("./ContractId");
var buffer_1 = require("buffer");
var Serialization_1 = require("../../Handlers/Serialization");
var lodash_1 = require("lodash");
var Spend_1 = require("./Spend");
var DiscriminatorEnum;
(function (DiscriminatorEnum) {
    DiscriminatorEnum[DiscriminatorEnum["PKRecipient"] = 1] = "PKRecipient";
    DiscriminatorEnum[DiscriminatorEnum["ContractRecipient"] = 2] = "ContractRecipient";
})(DiscriminatorEnum = exports.DiscriminatorEnum || (exports.DiscriminatorEnum = {}));
var Payout = /** @class */ (function () {
    function Payout(recipient, spends) {
        this.recipient = recipient;
        this.spends = spends;
        switch (recipient.kind) {
            case "PKRecipient":
                this.discriminator = DiscriminatorEnum.PKRecipient;
                break;
            case "ContractRecipient":
                this.discriminator = DiscriminatorEnum.ContractRecipient;
                break;
            default:
                throw 'recipient not implemented';
        }
    }
    Payout.read = function (buffer, offset) {
        var discriminant = buffer.readUInt8(offset);
        offset++;
        var recipient = undefined;
        switch (discriminant) {
            case DiscriminatorEnum.PKRecipient:
                var _a = Hash_1.Hash.read(buffer, offset), hash = _a.hash, offset_hash = _a.offset;
                recipient = { kind: "PKRecipient", hash: hash };
                offset = offset_hash;
                break;
            case DiscriminatorEnum.ContractRecipient:
                var _b = ContractId_1.ContractId.read(buffer, offset), contractId = _b.contractId, offset_contractId = _b.offset;
                recipient = { kind: "ContractRecipient", contractId: contractId };
                offset = offset_contractId;
                break;
            default:
                throw 'recipient not implemented';
        }
        var spendLength = buffer.readUInt8(offset);
        offset++;
        var spends = [];
        for (var i = 0; i < spendLength; i++) {
            var _c = Spend_1.Spend.read(buffer, offset), spend = _c.spend, outputOffset = _c.offset;
            spends.push(spend);
            offset = outputOffset;
        }
        return { payout: new Payout(recipient, spends), offset: offset };
    };
    Payout.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var payout = Payout.read(buffer, 0).payout;
        return payout;
    };
    Payout.prototype.getDiscriminator = function () {
        if (this.discriminator)
            return this.discriminator;
        throw "discriminator is not valid";
    };
    Payout.prototype.getRecipient = function () {
        if (this.recipient)
            return this.recipient;
        throw "recipient is not valid";
    };
    Payout.prototype.getSpends = function () {
        if (this.spends)
            return this.spends;
        throw "amount is not valid";
    };
    Payout.prototype.getSize = function () {
        //Option.Write
        var data = 1;
        switch (this.recipient.kind) {
            case "PKRecipient":
                data += this.recipient.hash.getSize() + Serialization_1.getSizeOfVarInt(this.spends.length) + lodash_1.sumBy(this.spends, function (spend) { return spend.getSize(); });
                break;
            case "ContractRecipient":
                data += this.recipient.contractId.getSize() + Serialization_1.getSizeOfVarInt(this.spends.length) + lodash_1.sumBy(this.spends, function (spend) { return spend.getSize(); });
                break;
            default:
                throw 'recipient not implemented';
        }
        return data;
    };
    Payout.prototype.toJson = function () {
        var data = {};
        switch (this.recipient.kind) {
            case "PKRecipient":
                data = this.recipient.hash.toJson();
                break;
            case "ContractRecipient":
                data = this.recipient.contractId.toJson();
                break;
            default:
                throw 'recipient not implemented';
        }
        return { recipient: data, spends: this.getSpends().map(function (spend) { return spend.toJson(); }) };
    };
    Payout.prototype.write = function (buffer, offset) {
        if (this.recipient) {
            offset = buffer.writeUInt8(this.getDiscriminator(), offset);
            switch (this.recipient.kind) {
                case "PKRecipient":
                    offset = this.recipient.hash.write(buffer, offset);
                    break;
                case "ContractRecipient":
                    offset = this.recipient.contractId.write(buffer, offset);
                    break;
                default:
                    throw 'recipient not implemented';
            }
            offset = buffer.writeUInt8(this.spends.length, offset);
            this.spends.forEach(function (spend) { return offset = spend.write(buffer, offset); });
        }
        return offset;
    };
    Payout.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Payout.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Payout;
}());
exports.Payout = Payout;
//# sourceMappingURL=Payout.js.map